export default __webpack_public_path__ + "bg138fefb.png";